var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82 40.76H70.44C60.96 40.76 53.24 33.04 53.24 23.56V12C53.24 9.8 51.44 8 49.24 8H32.28C19.96 8 10 16 10 30.28V65.72C10 80 19.96 88 32.28 88H63.72C76.04 88 86 80 86 65.72V44.76C86 42.56 84.2 40.76 82 40.76Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2007 8.83997C61.5607 7.19997 58.7207 8.31997 58.7207 10.6V24.56C58.7207 30.4 63.6807 35.24 69.7207 35.24C73.5207 35.28 78.8007 35.28 83.3207 35.28C85.6007 35.28 86.8007 32.6 85.2007 31C79.4407 25.2 69.1207 14.76 63.2007 8.83997Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1198 58.88C47.9598 57.72 46.0398 57.72 44.8798 58.88L41.9998 61.76V45C41.9998 43.36 40.6398 42 38.9998 42C37.3598 42 35.9998 43.36 35.9998 45V61.76L33.1198 58.88C31.9598 57.72 30.0398 57.72 28.8798 58.88C27.7198 60.04 27.7198 61.96 28.8798 63.12L36.8798 71.12C36.9198 71.16 36.9598 71.16 36.9598 71.2C37.1998 71.44 37.5198 71.64 37.8398 71.8C38.2398 71.92 38.5998 72 38.9998 72C39.3998 72 39.7598 71.92 40.1198 71.76C40.4798 71.6 40.7998 71.4 41.1198 71.12L49.1198 63.12C50.2798 61.96 50.2798 60.04 49.1198 58.88Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.46c746a722b65a90659cec123e1b2494.svg";
export { ForwardRef as ReactComponent };